// This function is depricated but I'm afraid to remove it. It was used to choose a random image for various pages,
// however the images are now only used for log-in and registration. These images chouls be hard coded.
export function randomNumber() {
    return Math.floor(Math.random() * 5) + 1;
}